import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id B22FEE66-3EC9-466A-9014-EF53030FA3D9
 * name star-box-outline
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-box-outline.svg
 * tags
 */
export const StarBoxOutlineIcon = createSvgIcon(<><path d="M15.58,17L12,14.84L8.42,17L9.37,12.93L6.21,10.2L10.38,9.84L12,6L13.62,9.83L17.79,10.19L14.63,12.92L15.58,17M19,3A2,2 0 0,1 21,5V19C21,20.11 20.1,21 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M5,5V19H19V5H5Z" /></>, 'StarBoxOutlineIcon');
export default StarBoxOutlineIcon